import { getResourceSlugFromType } from "~/modules/link-parser";
import { featuredImage } from "~/modules/images";
import { createComponent, FelaComponent } from "react-fela";
import { textStyles } from "~/styleguide/typography";
import { shadows, colors } from "~/styleguide";
import resourceData from "~/data/resource-shared-data.json";
import get from "lodash.get";

import FixedHeightExcerpt from "~/components/shared/fixed-height-excerpt";
import WordpressLink from "~/components/global/links";
import Visual from "~/components/shared/visual";
import readTime from "~/modules/read-time";

const stripHTML = text =>
    text
        ? text
              .replace(/<[^>]*>/g, " ")
              .replace(/\s+/g, " ")
              .trim()
        : "";

export default ({ resource, type, eyebrow, collectionLength, layout, extend }) => {
    let image = null;

    if (resource.acf && resource.acf.listing_image) {
        image = resource.acf.listing_image;

        const size = get(
            image,
            ["sizes", "medium_large"],
            get(image, ["sizes", "medium"])
        );
        if (size) image = size;
    } else {
        image = featuredImage(resource);
    }

    const excerpt = get(resource, "excerpt.rendered");
    const externalURL = get(resource, "external_url");
    const gridResourcePlaceholder = resourceData.data.acf.placeholder_image;
    const trueType = resource.type || type;
    const typeURL = getResourceSlugFromType(trueType);
    const title = get(resource, "title.rendered", "");
    const accessibleTitle = stripHTML(title);

    let eyebrowText = null;
    if (eyebrow == "type") {
        eyebrowText = resource.type_pretty;
    } else {
        eyebrowText = readTime(resource);
    }

    const renderLogo = () => {
        if (trueType == "casestudies" && resource.customer_logo) {
            return (
                <Visual
                    width="100"
                    height="30"
                    background="contain"
                    extend={logoStyle}
                    image={resource.customer_logo}
                />
            );
        }
    };

    return (
        <PostCard layout={layout} collectionLength={collectionLength} extend={extend}>
            {/* Image */}
            <WordpressLink
                url={externalURL || `/${typeURL}`}
                slug={resource.slug}
                ariaLabel={accessibleTitle}
            >
                <Visual
                    alt=""
                    extend={cardResourceImage}
                    image={image ? image : gridResourcePlaceholder}
                    aspect={16 / 9}
                    background="cover"
                />
            </WordpressLink>

            {/* Read time */}
            {eyebrowText && (
                <FelaComponent as="div" style={eyebrowElem}>
                    <FelaComponent style={eyebrowTextStyle} as="p">
                        {eyebrowText}
                    </FelaComponent>
                    {renderLogo()}
                </FelaComponent>
            )}

            {/* Title */}
            <WordpressLink
                url={externalURL || `/${typeURL}`}
                slug={resource.slug}
                label={title}
                extend={textStyles.resourceHeading}
            />

            {/* Excerpt */}
            {excerpt && (
                <FixedHeightExcerpt
                    extend={gridResourceExcerpt}
                    text={excerpt}
                ></FixedHeightExcerpt>
            )}
        </PostCard>
    );
};

const logoStyle = {
    marginTop: 25,
    filter: "grayscale(1)",
    opacity: 0.85
};

const cardResourceImage = {
    width: "calc(100% + 50px)",
    marginLeft: -25,
    marginTop: -25,

    "& .vv-visual": {
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6
    }
};

const eyebrowElem = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
};

const eyebrowTextStyle = {
    marginTop: 25
};

const gridResourceExcerpt = {
    marginTop: 15,
    lineHeight: 1.5
};

const PostCard = createComponent(({ collectionLength, layout }) => ({
    padding: "25px 25px 40px 25px",
    boxShadow: shadows.default,
    overflow: "hidden",
    background: colors.white,
    borderRadius: 6,
    willChange: "box-shadow",
    transition: "0.25s box-shadow ease",
    whenActive: {
        boxShadow: shadows.active
    },
    minWidthTabletLandscape: {
        grid: {
            cols: "3",
            margins: "30",
            length: collectionLength
        }
    },

    extend: [
        {
            condition: layout === "carousel",
            style: {
                maxWidthTabletLandscape: {
                    maxWidth: 280,
                    flexBasis: "100%",
                    marginRight: 20,
                    marginBottom: 5,
                    marginTop: 5,
                    ":last-child": {
                        marginRight: 0
                    }
                }
            }
        },
        {
            condition: layout === "grid",
            style: {
                maxWidthMobile: {
                    grid: {
                        cols: "1",
                        margins: "30",
                        length: collectionLength
                    }
                },
                minWidthMobile: {
                    maxWidthTabletLandscape: {
                        grid: {
                            cols: "2",
                            margins: "30",
                            length: collectionLength
                        }
                    }
                }
            }
        }
    ]
}));
